/* eslint-disable react/self-closing-comp */
// @ts-ignore
import React from "react";

import { SvgContainer } from "./svg-container";

export const BriefCaseIcon = () => {
    return (
        <SvgContainer>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="xMinYMin meet"
                viewBox="0 0 36 36"
                aria-hidden="true"
            >
                <path
                    fill="#ffffff"
                    fillRule="evenodd"
                    d="M12.06,6.06a6.06,6.06,0,1,1,12.11,0v2h-3v-2A3,3,0,0,0,18.2,3h-.09a3,3,0,0,0-3,3v2h-3ZM19.8,17.5H35.27V32a4,4,0,0,1-4,4H4.66a4,4,0,0,1-4-4V17.5H16.77v2.18a1.52,1.52,0,1,0,3,0Z"
                ></path>
                <path
                    opacity={0.5}
                    fill="#ffffff"
                    fillRule="evenodd"
                    d="M35.27,12.11a4,4,0,0,0-4-4H4.66a4,4,0,0,0-4,4V17.5H16.77V14.63a1.52,1.52,0,0,1,3,0V17.5H35.27Z"
                ></path>
            </svg>
        </SvgContainer>
    );
};
